<template>
    <div>
        <p @click="downloadFile" class="is-pointer">
            <span class="has-text-weight-bold">Respuesta: </span>
            {{ answer }}

            <Icon family="fa" name="fa-cloud-download-alt" />
        </p>
    </div>
</template>

<script>
const backendApiUrl = process.env.VUE_APP_BACKEND_API_URL;

export default {
    name: "sign-action-item",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: "",
        };
    },
    mounted() {
        let answer = this.action.answer;
        this.answer = answer ? "Firma" : "";
    },
    watch: {
        action: {
            deep: true,
            handler(action) {
                let answer = action.answer;
                this.answer = answer ? "Firma" : "";
            },
        },
    },
    methods: {
        async downloadFile() {
            window.open(
                `${backendApiUrl}api/files/share/${this.action.answer.fileId}`,
                "_blank"
            );
        },
    },
};
</script>